__turbopack_context__.v({
  "container": "style-module-scss-module__AlUrvq__container",
});
